import { inject } from '@angular/core';
import { ENV_CONFIG } from './env-config';

export abstract class BaseApiService {
    private readonly env = inject(ENV_CONFIG);
    protected readonly coreApiUrl = this.env.coreApiUrl;

    constructor() {
        if (!this.env.coreApiUrl) {
            throw new Error(
                'Missing required API URL in env config: coreApiUrl. ' +
                'Check assets/settings/env.json.'
            );
        }
    }
}
